<template>
  <div class="register">
    <LayoutHeader></LayoutHeader>
    <div class="register__container" v-if="!isRegisterSuccess">
      <div class="register__container-header flex flex--align-center">
        <router-link to="/login" replace>
          <v-icon type="iconround-clear-24px"></v-icon>
        </router-link>
        <div class="title">用户注册</div>
      </div>
      <div class="register__container-body">
        <Form :model="formData"
              :rules="rules"
              class="register__form"
              @on-validate="handleValidateFormItem"
              ref="form">
          <FormItem prop="fullName">
            <Input type="text"
                   @keyup.enter.native="handleSubmit"
                   placeholder="请输入用户名"
                   element-id="username"
                   :maxlength="20"
                   v-model.trim="formData.fullName" />
          </FormItem>
          <FormItem prop="phone">
            <Input type="text"
                   @keyup.enter.native="handleSubmit"
                   placeholder="请输入手机号码"
                   element-id="phone"
                   v-model.trim="formData.phone" />
          </FormItem>
          <FormItem prop="messageCode" class="register__msg-valid-item">
            <Input type="text"
                   @keyup.enter.native="handleSubmit"
                   placeholder="请输入短信验证码"
                   element-id="messageCode"
                   v-model="formData.messageCode" />
            <Button class="register__msg-valid-btn"
                    type="text"
                    :disabled="isSendMsgBtnDisabled"
                    @click="handleSendMsg"
            >{{sendMsgBtnText}}</Button>
          </FormItem>
          <FormItem prop="password">
            <Input type="password"
                   @keyup.enter.native="handleSubmit"
                   placeholder="请输入密码"
                   element-id="password"
                   password
                   v-model="formData.password" />
          </FormItem>
          <FormItem prop="rePassword">
            <Input type="password"
                   @keyup.enter.native="handleSubmit"
                   placeholder="请再次输入密码"
                   password
                   element-id="repassword"
                   v-model="formData.rePassword" />
          </FormItem>
          <FormItem prop="validateCode" class="register__valid-form-item">
            <Input placeholder="请输入验证码"
                   @keyup.enter.native="handleSubmit"
                   element-id="validateCode"
                   v-model="formData.validateCode" />
            <div class="register__valid-img">
              <img :src="validationCodeUrl"
                   alt="验证码"/>
              <p @click="getValidationCode">看不清楚? 换一张</p>
            </div>
          </FormItem>
          <FormItem prop="isCheckAgreement"
                    :class="isAgreementError ? 'register__error-agreement' : ''">
            <Checkbox v-model="formData.isCheckAgreement"
                      @on-change="handleAgreementChange">
              <span class="register-agreement">创建体素AI测肤开放平台帐号的同时，须遵守</span></Checkbox>
            <router-link to="/terms" target="_blank"><span class="register__agreement-btn">《用户服务协议》</span></router-link>
          </FormItem>
          <Button @click="handleSubmit"
                  long
                  :disabled="isSubmitDisabled"
                  type="primary"
                  :loading="loading"
                  shape="circle"
                  id="register">注册</Button>
          <p class="register__agreement-tip">
            <span v-if="isAgreementError">您需要勾选《用户服务协议》</span>
          </p>
        </Form>
      </div>
    </div>
    <vSuccessModal title="注册成功!" v-else></vSuccessModal>
  </div>
</template>

<script>
import { registration } from '@/api/user/user';
import msgCode from '@/mixins/user/msgCode';
import validationCode from '@/mixins/user/validationCode';
import LayoutHeader from '@/components/layout/layoutHeader.vue';
import { passwordToMd5 } from '@/utils/util';

export default {
  name: 'register',
  mixins: [msgCode, validationCode],
  components: {
    LayoutHeader,
  },
  data() {
    return {
      formData: {
        isCheckAgreement: false,
      },
      rules: {
        fullName: [{
          min: 6,
          max: 20,
          ...this.$rules.password,
          message: '用户名长度为6-20位，必须由阿拉伯数字和字母组成，请重新输入',
          trigger: 'blur',
        }],
        phone: [
          {
            ...this.$rules.mobileNumber,
            required: true,
            message: '手机号码格式不正确，请重新输入',
            trigger: 'blur',
          }],
        password: [{
          min: 8, message: '您输入的密码不符合规则，密码长度不能少于8位', trigger: 'blur',
        }],
        rePassword: [{
          min: 8, message: '您输入的密码不符合规则，密码长度不能少于8位', trigger: 'blur',
        }],
      },
      loading: false,
      isAgreementError: false,
      isRegisterSuccess: false,
    };
  },
  computed: {
    isSubmitDisabled() {
      return !(this.formData.fullName
            && this.$rules.mobileNumber.pattern.test(this.formData.phone)
            && this.formData.messageCode
            && this.formData.password
            && this.formData.rePassword
            && this.formData.validateCode);
    },
  },
  methods: {
    async handleSubmit() {
      if (this.loading || this.isSubmitDisabled) {
        return false;
      }
      const {
        fullName, phone, messageCode, password,
        rePassword, isCheckAgreement, validateCode,
      } = this.formData;
      if (!isCheckAgreement) {
        this.isAgreementError = true;
        return false;
      }
      if (password && rePassword && password !== rePassword) {
        this.$Message.error('两次输入的密码不一致，请重新输入');
        return false;
      }
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        const res = await registration({
          full_name: fullName,
          phone,
          code: messageCode,
          password: passwordToMd5(password),
          validation_code: validateCode,
        });
        if (res) {
          this.isRegisterSuccess = true;
        } else {
          this.getValidationCode();
        }
        this.loading = false;
      }
      return false;
    },
    handleAgreementChange(val) {
      if (val) {
        this.isAgreementError = false;
      }
    },
  },
};
</script>

<style lang="less">
  @prefix: ~'register';
  .@{prefix} {
    width: 100vw;
    height: 100vh;
    background-image: url("../../assets/login/bg-login.jpeg");
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
    position: relative;
    min-height: 880px;
    &__container {
      width: 560px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: -40px;
      box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .1),
      0 6px 30px 5px rgba(0, 0, 0, .08),
      0 8px 10px 0 rgba(0, 0, 0, .16);
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      &-header{
        height: 56px;
        background-color: rgb(81, 69, 139);
        padding: 0 16px;
        .v-icon{
          color: #fff;
          cursor: pointer;
        }
        .title{
          color: #fff;
          flex: 1;
          padding-left: 30px;
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
        }
      }
      &-body{
        padding: 22px 16px 46px;
        .@{prefix}__msg-valid-btn{
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          padding: 0;
          box-shadow: none;
          height: 36px;
          font-size: 14px;
          font-weight: 500;
          color: @primary-color;
          &[disabled]{
            color: #bfbfbf;
            background-color: transparent;
            &:hover{
              color: #bfbfbf;
              background-color: transparent;
            }
          }
          &:hover{
            background-color: transparent;
          }
        }
        .ivu-form-item{
          margin-bottom: 36px;
          &.@{prefix}__error-agreement{
            .ivu-checkbox-wrapper{
              span{
                color: rgb(255, 152, 0);
              }
            }
            .ivu-checkbox-inner{
              border-color: rgb(255, 152, 0);
            }
            .@{prefix}__agreement-btn{
              color: rgb(255, 152, 0);
            }
          }
        }
        .ivu-input{
          border-color: rgba(0, 0, 0, 0.12);
          border-radius: 8px;
          height: 36px;
          line-height: 36px;
          padding: 0 16px;
          color: #000;
          &:focus{
            border-color: @primary-color;
          }
        }
        .ivu-input-suffix i{
          line-height: 36px;
          font-size: 20px;
        }
        .ivu-btn-long{
          padding: 0;
          height: 36px;
          font-size: 14px;
          font-weight: 500;
          &[disabled] {
            background-color: rgba(0, 0, 0, 0.12);
            border: none;
            color: rgba(0, 0, 0, 0.26);
            &:hover{
              background-color: rgba(0, 0, 0, 0.12);
              border: none;
              color: rgba(0, 0, 0, 0.26);
            }
          }
        }
        .ivu-checkbox-inner{
          border-color: rgba(0, 0, 0, 0.54);
        }
        .ivu-checkbox-wrapper{
          margin-right: 0;
        }
      }
    }
    &__valid-form-item.ivu-form-item{
      padding-right: 144px;
      position: relative;
      margin-bottom: 40px;
    }
    &__valid-img{
      position: absolute;
      width: 140px;
      text-align: right;
      top: 0;
      right: -144px;
      img{
        width: 103px;
        height: 34px;
        vertical-align: middle;
      }
      p{
        line-height: 20px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 500;
        cursor: pointer;
        &:hover{
          color: @primary-color;
        }
      }
    }
    &__msg-valid-item{
      position: relative;
    }
    &__agreement-btn{
      color: @primary-color;
      vertical-align: middle;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
    &__agreement-tip{
      text-align: center;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.54);
      padding-top: 6px;
      height: 18px;
      line-height: 18px;
    }
  }
</style>
